import HorizontalScrollMedia from '@/components/HorizontalScrollMedia';
import { ImageWithFallback } from '@/components/ui/fallbackImage';
import { IMAGES_BASE_URL } from '@/lib/config';
import type { GolfClub } from '@/pages/GolfSearch';
import { IonButton, IonRouterLink, IonSpinner } from '@ionic/react';
import { useTranslation } from 'react-i18next';

interface NearestExplorerProps {
  nearbyClubs: GolfClub[];
  isLoading: boolean;
  userLocation: { latitude: number; longitude: number; city?: string } | null;
}

const ExploreNearest: React.FC<NearestExplorerProps> = ({
  nearbyClubs,
  isLoading,
  userLocation
}) => {
  const { t } = useTranslation();

  if (!userLocation || nearbyClubs.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex justify-between items-center my-2">
        <h2 className="font-semibold ml-4">{t('golf_near_me')} {userLocation?.city ? ` - (${userLocation.city})` : ''}</h2>
        <IonButton fill="clear" size="small" routerLink="/s">
          {t('see_all')}
        </IonButton>
      </div>
      <HorizontalScrollMedia disableArrows>
        {isLoading ? (
          <div className="flex justify-center w-full py-8">
            <IonSpinner />
          </div>
        ) : (
          nearbyClubs.map((club) => (
            <IonRouterLink
              className="cursor-pointer ml-4 overflow-hidden"
              key={club.id}
              routerLink={`/c/${club.slug}`}
            >
              <div className="relative group">
                <ImageWithFallback
                  alt={`${club.name} photo`}
                  fallbackImage="/assets/images/course_fallback.webp"
                  src={club.thumbnail ? club.thumbnail : `${IMAGES_BASE_URL}/${club.id}.jpg`}
                  className="w-48 h-52 md:w-56 md:h-64 object-cover rounded-md brightness-75"
                />
                <div className="absolute inset-0 shadow-lg flex items-end justify-start p-6">
                  <div className="text-white">
                    <div className="text-lg font-bold" style={{ textShadow: '1px 1px 0 rgba(0,0,0,0.35), 1px 1px 5px rgba(0,0,0,0.5)' }}>
                      {club.name}
                    </div>
                    <div className="text-sm" style={{ textShadow: '1px 1px 0 rgba(0,0,0,0.35), 1px 1px 5px rgba(0,0,0,0.5)' }}>
                      {club.distance ? `${club.distance} km` : ''}
                    </div>
                  </div>
                </div>
              </div>
            </IonRouterLink>
          ))
        )}
      </HorizontalScrollMedia>
    </>
  );
};

export default ExploreNearest;
